import React from 'react';
import { MediaGroup } from 'src/components/complex';
import QRCode from 'src/components/basic/QRCode';

import { isAdminPage, lang, permissions, remCss, userFullName, withRouter } from 'src/helpers';

import { MCButton, MCText, View } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import { remFontCss } from '../../public/Clinic/utils';

class LeftDetail extends React.PureComponent {
  render() {
    const doctor = this.props.detail || this.props;
    if (!doctor.id) return null;
    let images = doctor.images || [];
    if (doctor.avatar) images = [doctor.avatar, ...images];
    let online = doctor.online || doctor.partnerOnline > 0;

    return (
      <div className={'mc-content-left'}>
        {online && <div className={'mc-online'}>{lang.t('Online')}</div>}
        <MediaGroup images={images} />
        {!this.props.isAdminPage && (
          <div className={'mc-flex mc-mt20'}>
            <MCButton
              primary
              dark
              medium
              radius
              flex
              onClick={() => {
                if (isAdminPage()) {
                  this.props.router.navigate(
                    permissions.PAGES.ADMIN_MESSAGES_USER_PAGE.match(doctor.username)
                  );
                } else
                  this.props.router.navigate(
                    permissions.PAGES.MESSAGES_USER_PAGE.match(doctor.username)
                  );
              }}
            >
              {lang.t(LANG_CONST.buttons.send_a_message)}
            </MCButton>
          </div>
        )}
        <div className={'mc-name'}>{userFullName(doctor)}</div>

        <View style={{ paddingTop: remCss(15), paddingBottom: remCss(25), gap: remCss(15) }}>
          <View style={{ gap: remCss(10) }}>
            <MCText label={LANG_CONST.speciality} size={18} weight={400} textLight />
            <View
              style={{
                flexDirection: 'row',
                gap: remCss(10),
                flexWrap: 'wrap'
              }}
            >
              {doctor.specialist?.map(
                (s) =>
                  LANG_CONST.constants.specialist[s] && (
                    <MCButton key={s} shadow rounded>
                      <MCText
                        size={remFontCss(20)}
                        weight={400}
                        heading
                        label={LANG_CONST.constants.specialist[s]}
                      />
                    </MCButton>
                  )
              )}
            </View>
          </View>

          {doctor.subSpeciality && (
            <View style={{ gap: remCss(10) }}>
              <MCText
                label={LANG_CONST.sub_speciality}
                size={remFontCss(18)}
                weight={400}
                textLight
              />
              <View
                style={{
                  flexDirection: 'row'
                }}
              >
                <MCButton shadow rounded>
                  <MCText label={doctor.subSpeciality} size={remFontCss(20)} weight={400} heading />
                </MCButton>
              </View>
            </View>
          )}
        </View>
        <QRCode
          action={'doctor_' + doctor.username}
          skipShorten={false}
          className='mc-text-center'
        />
      </div>
    );
  }
}

export default withRouter(LeftDetail);
